import React from "react";
import Screen1 from "../../assets/images/Screen1.png"
import Screen2 from "../../assets/images/Screen2.png"
import Screen3 from "../../assets/images/Screen3.png"
import IconArrowRight from "../../assets/images/icon_arrow_right.png"
import {AutomatedCampaignType} from "./dataForActiveCampaign";
import {dataForAutomationCampaign, SubCampaignTypeItem} from "./campaignTypeSelection";

interface IProps {
    onClick: (type: AutomatedCampaignType) => void
}

export default function EmptyCampaign(props: IProps) {
    const {onClick} = props

    const $header = (
        <div className={"space-y-2"}>
            <p className={"font-bold text-3xl text-gray-1 text-center"}>Welcome</p>
            <p className={"text-sm text-gray-1 text-left"}>Get started by creating your first SMS Campaign. You will first need to create /select a patient group and then design your campaign. Lastly you get to test before sending out the campaign.  </p>
        </div>
    )

    const $guideItem1 = (
        <div className={"h-40 flex flex-none flex-col space-y-1 items-center justify-between"}>
            <img src={Screen1} className={"w-44 h-auto"}/>
            <p className={"text-gray-1 text-xs"}>Select your campaign audience</p>
        </div>
    )
    const $guideItem2 = (
        <div className={"h-40 flex flex-none flex-col space-y-1 items-center justify-between"}>
            <img src={Screen2} className={"w-44 h-auto"}/>
            <p className={"text-gray-1 text-xs"}>Design your campaign</p>
        </div>
    )
    const $guideItem3 = (
        <div className={"h-40 flex flex-none flex-col space-y-1 items-center justify-between"}>
            <img src={Screen3} className={"w-44 h-auto"}/>
            <p className={"text-gray-1 text-xs"}>Test and Send</p>
        </div>
    )

    const $arrow = (
        <img src={IconArrowRight} className={"transform rotate-90 lg:rotate-0 w-6 h-6"}/>
    )

    const $guideImages = (
        <div className={"w-full flex flex-col pt-9 pb-14 space-y-2 lg:space-y-0 lg:flex-row items-center justify-between"}>
            {$guideItem1}
            {$arrow}
            {$guideItem2}
            {$arrow}
            {$guideItem3}
        </div>
    )

    const $automatedCampaignItem = (item: SubCampaignTypeItem, idx: number) => {
        const {title, type, description, icon} = item
        return (
            <div key={`${title}_${idx}`} className={"flex flex-1 flex-row items-center space-x-10 py-4 px-10 border border-gray-200 shadow-md rounded cursor-pointer hover:border-primary"} onClick={() => {
                onClick && onClick(type)
            }}>
                <div className={"flex flex-none"}>
                    {icon}
                </div>
                <div className={"flex flex-1 flex-col space-y-2"}>
                    <p className={"text-sm font-semibold"}>{title}</p>
                    <p className={"text-xs w-full"}>{description}</p>
                </div>
            </div>
        )
    }

    const $automatedCampaigns = (
        <div className={"w-full text-left space-y-4"}>
            <div className={"flex flex-1 flex-col pb-2 space-y-2 border-b"}>
                <p className={"text-2xl text-gray-1 font-bold"}>Automated Campaign</p>
                <p className={"text-xs w-full"}>Create a campaign, which you can select to send as an automation action.</p>
            </div>

            {dataForAutomationCampaign.map((item, idx) => $automatedCampaignItem(item, idx))}
        </div>
    )
    return (
        <div className={"flex-none bg-white py-10 lg:py-20 flex flex-col items-center w-full rounded shadow-lg"}>
            <div className={"w-full max-w-2xl flex flex-col items-center px-4 lg:px-0"}>
                {$header}
                {$guideImages}
                {$automatedCampaigns}
            </div>
        </div>
    )
}
